import React from "react";
import styled from "styled-components";
import { FontSize, FontWeight, form, prettyScrollbars } from "@glossy";
import { Size, VARIANTS, Variant, padding, radius } from "../styles";

interface IProps {
  content: string;
  size?: Size;
  variant?: Variant;
  onChange: (value: string) => void;
  minHeight?: number;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

const Textarea = styled.textarea<{
  $size: Size;
  minHeight: number;
  variant: Variant;
}>`
  height: auto;
  width: 100%;
  padding: ${padding}px;
  min-height: ${(props) => props.minHeight}px;
  box-sizing: border-box;
  border-radius: ${radius}px;
  color: ${form};
  font-weight: ${FontWeight.Normal};
  font-size: ${FontSize.Medium};
  resize: none;
  border: none;
  ${prettyScrollbars()};
  ::placeholder {
    opacity: 0.7;
    color: ${form};
  }

  ${(props) => VARIANTS[props.variant]};
`;

const UiKitFormTextarea = ({
  content,
  size = "m",
  variant = "secondary",
  onChange,
  minHeight = 150,
  className,
  placeholder,
  disabled,
}: IProps) => (
  <Textarea
    className={className}
    minHeight={minHeight}
    value={content}
    placeholder={placeholder}
    $size={size}
    variant={variant}
    disabled={disabled}
    onChange={(e) => onChange(e.target.value)}
  />
);

export default UiKitFormTextarea;
